import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Components
// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';

// Global Actions
import { requestSubmitMultipleTimesheets } from 'services/timesheets/actions';

import { makeSelectFilteredSelectedTimesheets } from 'services/timesheets/selectors';

interface ConnectedProps {
    timesheetIds?: number[];
}

interface DispatchProps {
    requestSubmitMultipleTimesheets: Function;
}

export interface Props extends ConnectedProps, DispatchProps {}

export class SubmitMultipleTimesheetModalButton extends React.PureComponent<
    Props
> {
    handleClick = (): void => {
        const { timesheetIds } = this.props;
        this.props.requestSubmitMultipleTimesheets(timesheetIds);
    };

    render(): React.ReactElement {
        const { timesheetIds } = this.props;

        return (
            <SubmittingButton
                type="submit"
                namespace="TIMESHEET_MULTIPLE_SUBMIT"
                primary
                fluid
                onClick={this.handleClick}
                disabled={!timesheetIds || !timesheetIds.length}
            >
                Confirm
            </SubmittingButton>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    timesheetIds: makeSelectFilteredSelectedTimesheets()
});

export default connect(
    mapStateToProps,
    { requestSubmitMultipleTimesheets }
)(SubmitMultipleTimesheetModalButton);
